<template>
    <div class="app-content">
        <ContentLeftSide class="app-content-left-side"/>
        <ContentRightSide class="app-content-right-side"/>
        <transition>
            <button class="content-random-selection-button" @click="showWinner()">
                Select a restaurant for me!
            </button>
        </transition>
    </div>
</template>

<script>
    import ContentLeftSide from "./ContentLeftSide";
    import ContentRightSide from "./ContentRightSide";

    export default {
        name: "AppContent",
        components: {ContentRightSide, ContentLeftSide},
        data() {
            return {
            }
        },
        methods: {
            showWinner() {
                try {
                    this.selectALocation();
                } catch (e) {
                    this.$notify({
                        group: 'google-maps-api-notifications',
                        type: 'warn',
                        title: 'Restaurants',
                        closeOnClick: 'true',
                        text: e,
                        // 'There are no restaurants!'
                    });
                }
            },
            selectALocation() {
                this.$store.dispatch('selectALocation')
            },
        }
    }
</script>

<style scoped>

    .app-content {
        position: relative;
        display: flex;
        flex-flow: row wrap;
        -webkit-flex-flow: row wrap;
        justify-content: center;
        margin: 1vh 2vw 1vh 2vw;
        padding: 0;
        opacity: 1;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
    }

    .app-content-left-side {
        height: 75vh;
        width: 90vw;
        flex-grow: 4;
        order: 1;
    }

    .app-content-right-side {
        width: 90vw;
        flex-grow: 1;
        order: 2;
        overflow-y: hidden;
    }

    .content-random-selection-button {

        /*margin: 1vh 2vw 1vh 2vw;*/
        /*padding: 0;*/

        position: fixed;
        bottom: 10px;


        z-index: 6;

        display: flex;

        align-items: center;
        justify-content: center;

        opacity: 1;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);

        flex-grow: 1;
        order: 2;


        padding: 1px 32px;
        margin: 6px 4px;
        text-align: center;
        text-decoration: none;
        font-size: 16px;
        height: 48px;
        -webkit-transition-duration: 0.4s; /* Safari */
        transition-duration: 0.4s;

        animation: shadow-pulse 2s ease-out 5s forwards;

        cursor: pointer;
        background-color: #3690c0;
        border: 0;
        color: black;
        border-radius: 8px;
    }

    .content-random-selection-button:hover {
        background-color: #e7e7e7;
    }

    @keyframes shadow-pulse
    {
        0% {
            box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2);
        }
        100% {
            box-shadow: 0 0 0 35px rgba(0, 0, 0, 0);
        }
    }

    @media all and (min-width: 640px) {
        .content-random-selection-button {
            position: absolute;
            top: -16px;
        }

        .app-content-left-side {
            width: 45vw;
            height: auto;
        }

        .app-content-right-side {
            width: 45vw;
        }
    }
</style>